package com.eladfinish.bible.contest.utils

fun Int.toOtiot(): String = getOtiot(this)

//    gematria, gimatria
// convert number to hebrew letters
fun getOtiot(num: Int): String {
    var str: String
    str = meot(num) + asarot(num) + ahadot(num)
    if (num % 100 == 15) str = meot(num) + "טו" else if (num % 100 == 16) str = meot(num) + "טז"
    return str
}

private fun ahadot(num: Int) = when (num % 10) {
    1 -> "א"
    2 -> "ב"
    3 -> "ג"
    4 -> "ד"
    5 -> "ה"
    6 -> "ו"
    7 -> "ז"
    8 -> "ח"
    9 -> "ט"
    else -> ""
}

private fun asarot(num: Int) = when (num % 100 / 10) {
    1 -> "י"
    2 -> "כ"
    3 -> "ל"
    4 -> "מ"
    5 -> "נ"
    6 -> "ס"
    7 -> "ע"
    8 -> "פ"
    9 -> "צ"
    else -> ""
}

private fun meot(num: Int) = when (num / 100) {
    1 -> "ק"
    2 -> "ר"
    3 -> "ש"
    4 -> "ת"
    else -> ""
}
